export default __webpack_public_path__ + "7d48372aea973faff9041014902becd4.png";